import { Link } from 'react-router-dom'
import styled from 'styled-components'

type JobThumbProps = {
  image: string
  name: string
  id: number
}

function JobThumb(job: JobThumbProps) {
  return (
    <Link to={'/job/' + job.id}>
      <Container>
        <img src={job.image} width="90" height="90" className="image" />
        <JobTitle>{job.name}</JobTitle>
      </Container>
    </Link>
  )
}

const Container = styled.div`
  padding: 0;

  .image {
    width: 90px;
  }
`
const JobTitle = styled.div`
  padding: 0 0 7px 0;
  color: #666;
  font-size: 14px;
  text-align: center;

  @media (max-width: 768px) {
    width: 100%;
  }
`

export default JobThumb
